import "./CouponForm.scss";
import React from "react";
import {Form, Input} from "antd";
import CustomButton from "../UI/CustomButton/CustomButton";
import {useTranslation} from "react-i18next";
import {CouponService} from "../../services/coupon.service";
import {ICoupon, ICouponError} from "../../models/Coupon";

interface ICouponFormProps {
    coupon: ICoupon | ICouponError | {};
    setCoupon: (value: ICoupon | ICouponError) => void;
    scope: "subscription" | "dropIn" | "appointment";
}

const CouponForm: React.FC<ICouponFormProps> = ({coupon, setCoupon, scope}) => {

    const {t} = useTranslation();

    const onFinish = (values: {couponCode: string}) => {
        checkCouponCode(values.couponCode);
    };

    const checkCouponCode = async (couponCode: string) => {
        try {
            const response = await CouponService.getSubscriptionActiveCoupons(couponCode, scope);
            setCoupon(response.data);
        } catch (e) {}
    }

    const initialValues = {
        couponCode: "couponCode" in coupon && coupon.couponCode ? coupon.couponCode : "",
    };

    return (
        <div className="coupon-form-component">
            <p className="label">{t("CouponCode")}</p>

            <Form
                className="coupon-form"
                name="coupon-form"
                onFinish={onFinish}
                autoComplete="off"
                initialValues={initialValues}
            >
                <div className="row">
                    <Form.Item
                        className={coupon && Object.keys(coupon).length > 0 ? ("error" in coupon && coupon.error ? "no_valid" : "valid") : ""}
                        name="couponCode"
                    >
                        <Input
                            className={coupon && Object.keys(coupon).length > 0 ? ("error" in coupon && coupon.error ? "no_valid__text" : "valid__text") : ""}
                            placeholder={t("EnterCoupon")}/>
                    </Form.Item>

                    <div className={"btn-wrapper"}>
                        <CustomButton text={t("Apply")} type={"submit"} typeStyle={"outline"} borderRadius={false} blueForOutline={true}/>
                    </div>

                </div>
                {
                    coupon && Object.keys(coupon).length > 0 ? ("error" in coupon && coupon.error ?
                            <p className={"no_valid__text"}>{t("CouponNotValid")}</p>
                            :
                            <p className={"valid__text"}>{t("CouponIsValid", {discount: "discount" in coupon ? coupon.discount : 0})}</p>)
                        : <p></p>

                }

            </Form>

        </div>
    )
}

export default CouponForm;